import React from "react";
import Header from "./component/Header"
import Footer from "./component/Footer"
import Router from "./router/"
import { useLocation } from "react-router-dom";
import 'antd/dist/antd.css';
const App = () => {
  const location = useLocation();
  const { pathname } = location
  return <>
    <Header />
    <Router />
    {!pathname.includes('business') && <Footer />}
  </>
};

export default App
